import { Input, Label, Tooltip } from '@iwoca/orion';
import { Trans, useLingui } from '@lingui/react/macro';
import { useFormContext } from 'react-hook-form';

import styles from './AddressField.module.css';
import { TPersonalDetailsDataDE } from '../../PersonalDetailsDE';

const AddressField = () => {
  const { t } = useLingui();

  const {
    register,
    formState: { errors },
  } = useFormContext<TPersonalDetailsDataDE>();

  return (
    <>
      <div className={styles.formFieldGroup}>
        <div className={styles.formFieldStreet}>
          <div className={styles.formLabel}>
            <Label htmlFor="streetLine1">
              <Trans>Street</Trans>
            </Label>
            <Tooltip
              content={t`We need your current registration address as it appears on your ID.`}
            />
          </div>
          <Input
            {...register('streetLine1')}
            id="streetLine1"
            placeholder={t`e.g. Street`}
            error={errors.streetLine1?.message}
            className="fs-mask"
          />
        </div>
        <div>
          <Input
            {...register('houseNumber')}
            placeholder={t`e.g. 21`}
            label={t`House number`}
            error={errors.houseNumber?.message}
            className="fs-mask"
          />
        </div>
      </div>
      <div className={styles.formField}>
        <Input
          {...register('streetLine2')}
          placeholder={t`e.g. Apartment 2`}
          label={t`Additional address (optional)`}
          error={errors.streetLine2?.message}
          className="fs-mask"
        />
      </div>
      <div className={styles.formFieldGroup}>
        <div className={styles.formFieldPostcode}>
          <Input
            {...register('postcode')}
            placeholder={t`e.g. 37269`}
            label={t`Postcode`}
            error={errors.postcode?.message}
            className="fs-mask"
          />
        </div>
        <Input
          {...register('town')}
          placeholder={t`e.g. London`}
          label={t`Town`}
          error={errors.town?.message}
          className="fs-mask"
        />
      </div>
    </>
  );
};

export default AddressField;
